import { CurrencyDollarIcon } from '@repo/studio-design-system-ui-icons/finance-ecommerce/currency-dollar'
import { Button } from '@repo/studio-design-system-ui-button'
import type { ButtonVariant } from '@repo/studio-design-system-ui-button'
import { ROUTES } from '@repo/studio-utils/routes'
import { useStudioTranslate } from '@repo/studio-config/studio-config-context'
import { useStudioNavigateTo } from '@repo/studio-config/studio-config-router'

function useEarnAction() {
  const t = useStudioTranslate()
  const navigateTo = useStudioNavigateTo()

  return {
    label: t('studio.home.earn'),
    goToAffiliates: () => navigateTo(ROUTES.AFFILIATES.ROOT),
  }
}

export function EarnButton({ variant = 'promotional' }: { variant?: ButtonVariant }) {
  const { label, goToAffiliates } = useEarnAction()

  return (
    <Button type="button" size="sm" variant={variant} onClick={goToAffiliates}>
      <CurrencyDollarIcon />
      {label}
    </Button>
  )
}

export function EarnIconButton({ variant = 'promotional' }: { variant?: ButtonVariant }) {
  const { label, goToAffiliates } = useEarnAction()

  return (
    <Button
      type="button"
      size="sm"
      variant={variant}
      iconOnly
      aria-label={label}
      onClick={goToAffiliates}
    >
      <CurrencyDollarIcon />
    </Button>
  )
}
